export const items = [
  // {"itemCode": "DIPR1030"},
  // {"itemCode": "GLUC2001"},
  // {"itemCode": "GLUC2002"},
  // {"itemCode": "GLUC2003"},
  // {"itemCode": "GLUC2004"},
  // {"itemCode": "GLUC2005"},
  // {"itemCode": "GLUC2006"}
  // {"itemCode": "RAPT2002"}
]

export const blockedItems = new Map(items.map(item => [item.itemCode]));